import {
  ResolutionSearchArticlesQuery,
  SuggestionsByTagQuery,
  SuggestionsQuery,
} from 'components/conversation/components/integrations/elevio/src/apis/graphQl/elevio/grappa/types/grappa.types';

import { ArticleSuggestion } from '../types';

/**
 * Transforms data from ResolutionSearchArticlesQuery into a universal format of
 * ArticleSuggestion[]
 */
export function transformResolutionSearchArticles(
  articleSuggestions?: ResolutionSearchArticlesQuery,
): ArticleSuggestion[] {
  if (!articleSuggestions) return [];

  const suggestions: ArticleSuggestion[] =
    articleSuggestions.searchArticles.results.map(
      ({ accessControl, id, slug, title, tags, category }) => {
        const articleData: ArticleSuggestion = {
          accessControl,
          category,
          id,
          slug,
          title,
          tags,
        };
        return articleData;
      },
    );

  return suggestions;
}

/** Transforms suggestions data */
export function transformSuggestions(
  suggestionData?: SuggestionsQuery | SuggestionsByTagQuery,
): ArticleSuggestion[] {
  if (!suggestionData) return [];

  const suggestions: ArticleSuggestion[] =
    suggestionData.suggestedArticles.results.map((result) => {
      const suggestion: ArticleSuggestion = {
        ...result,
        __typename: 'ArticleSearchResult',
      };
      return suggestion;
    });

  return suggestions;
}
